import React from 'react';
import DepositMethodFactory from 'js/components/main/QuickDeposit/Deposit/DepositMethodFactory';
import Empty from 'js/components/main/QuickDeposit/QuickDeposit/Empty';
import { usePortletSelector } from '@core/js/components/system/Portlet';
import { pickPaths } from '@core/js/utils/methods.util';
import { withQuickDeposit } from 'js/components/main/QuickDeposit/QuickDeposit/QuickDeposit';
import style from './index.scss';

export const QuickDepositBare = (props) => {
    const {
        isEmpty
    } = usePortletSelector(pickPaths([
        ['isEmpty']
    ]));

    if (isEmpty) {
        return <Empty />;
    }

    return (
        <div className={`${style.container} cms-quick-deposit`}>
            <div className={style.body}>
                <DepositMethodFactory {...props} />
            </div>
        </div>
    );
};

export const QuickDeposit = withQuickDeposit(QuickDepositBare);

export default QuickDeposit;
